import type { CalculatorFormValues } from "./types"
import type { CalculationResult } from "@/shared/lib/staffing-shared"

/**
 * Call the prediction edge function to calculate staffing
 */
export async function callPredictionAPI(
  formValues: CalculatorFormValues,
): Promise<CalculationResult | null> {
  try {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
    const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

    if (!supabaseUrl || !supabaseAnonKey) {
      console.error("Supabase credentials not configured")
      return null
    }

    const response = await fetch(`${supabaseUrl}/functions/v1/prediction`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${supabaseAnonKey}`,
        apikey: supabaseAnonKey,
      },
      body: JSON.stringify(formValues),
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: "Unknown error" }))
      console.error("Prediction API error:", errorData)
      return null
    }

    const result = await response.json()
    return result as CalculationResult
  } catch (error) {
    console.error("Error calling prediction API:", error)
    return null
  }
}
